/**
 * @generated SignedSource<<16ebb41cbb52b5b1bb6aeb74c370416c>>
 * @relayHash 616e3e4e01c7bb341b609014f786ef61
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f6fa8de41da6097196b83fca05901df819b27fa2f1b19a3e601b4ce00aff2e38

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type OptInModalQuery$variables = {
  projectAri: string;
};
export type OptInModalQuery$data = {
  readonly project: {
    readonly associatedFieldConfigScheme?: {
      readonly name: string | null | undefined;
      readonly schemeId: string | null | undefined;
    } | null | undefined;
    readonly associatedFieldScheme?: {
      readonly name: string | null | undefined;
      readonly schemeId: string | null | undefined;
    } | null | undefined;
    readonly name?: string;
    readonly projectId?: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"OptInModal" | "OptInModal_legacySchemes">;
  } | null | undefined;
};
export type OptInModalQuery = {
  response: OptInModalQuery$data;
  variables: OptInModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "projectAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "projectId"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "ScalarField",
  "name": "schemeId"
},
v5 = [
  (v4/*: any*/),
  (v3/*: any*/)
],
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = [
  (v4/*: any*/),
  (v3/*: any*/),
  (v7/*: any*/)
],
v9 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 40
  }
],
v10 = [
  (v4/*: any*/),
  (v3/*: any*/),
  (v7/*: any*/),
  (v6/*: any*/)
],
v11 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v12 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v13 = [
  "input"
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "OptInModalQuery",
    "selections": [
      {
        "alias": "project",
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraFieldConfigScheme",
                "kind": "LinkedField",
                "name": "associatedFieldConfigScheme",
                "plural": false,
                "selections": (v5/*: any*/)
              },
              {
                "concreteType": "JiraFieldScheme",
                "kind": "LinkedField",
                "name": "associatedFieldScheme",
                "plural": false,
                "selections": (v5/*: any*/)
              },
              {
                "kind": "FragmentSpread",
                "name": "OptInModal"
              },
              {
                "kind": "FragmentSpread",
                "name": "OptInModal_legacySchemes"
              }
            ],
            "type": "JiraProject"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OptInModalQuery",
    "selections": [
      {
        "alias": "project",
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraFieldConfigScheme",
                "kind": "LinkedField",
                "name": "associatedFieldConfigScheme",
                "plural": false,
                "selections": (v8/*: any*/)
              },
              {
                "concreteType": "JiraFieldScheme",
                "kind": "LinkedField",
                "name": "associatedFieldScheme",
                "plural": false,
                "selections": (v8/*: any*/)
              },
              {
                "args": (v9/*: any*/),
                "concreteType": "JiraFieldSchemesConnection",
                "kind": "LinkedField",
                "name": "availableFieldSchemes",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFieldSchemesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraFieldScheme",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v10/*: any*/)
                      },
                      (v11/*: any*/)
                    ]
                  },
                  (v12/*: any*/)
                ],
                "storageKey": "availableFieldSchemes(first:40)"
              },
              {
                "args": (v9/*: any*/),
                "filters": (v13/*: any*/),
                "handle": "connection",
                "key": "OptInModal_adminPagesFieldSchemes__availableFieldSchemes",
                "kind": "LinkedHandle",
                "name": "availableFieldSchemes"
              },
              {
                "args": (v9/*: any*/),
                "concreteType": "JiraFieldConfigSchemesConnection",
                "kind": "LinkedField",
                "name": "availableFieldConfigSchemes",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFieldConfigSchemesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraFieldConfigScheme",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v10/*: any*/)
                      },
                      (v11/*: any*/)
                    ]
                  },
                  (v12/*: any*/)
                ],
                "storageKey": "availableFieldConfigSchemes(first:40)"
              },
              {
                "args": (v9/*: any*/),
                "filters": (v13/*: any*/),
                "handle": "connection",
                "key": "OptInModal_adminPagesFieldSchemes__availableFieldConfigSchemes",
                "kind": "LinkedHandle",
                "name": "availableFieldConfigSchemes"
              }
            ],
            "type": "JiraProject"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "f6fa8de41da6097196b83fca05901df819b27fa2f1b19a3e601b4ce00aff2e38",
    "metadata": {},
    "name": "OptInModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3f737f4710f7d57d9050b2303e588d53";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
